// this file is generated by update_shopify_store_data.py at 2026-11-03 20:11:31.675364
var courses = [
    {
        "course_id": "0DA789F1-7C8B-F111-99B2-005056A7F5E9",
        "course_version": 1,
        "name": "AAENP - Professional Practice Bundle",
        "course_type": 32,
        "author_information": "",
        "description": "Clinical expertise is only part of the job. The ENP Professional Practice Bundle covers everything that surrounds it \u2014 malpractice exposure, the hardest conversations in medicine, the self-doubt that follows high performers, the policy levers available to nurse practitioners, and the social forces that determine whether your care actually reaches the patient. This is professional practice instruction designed to empower NPs to optimize and expand their practice. \r\n\r\n8 Courses Included",
        "learning_objectives_html": "At the conclusion, participants should be able to:",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Medicine",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Services",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4033B9A8-CF89-F111-99B9-005056A7EBB6",
                "course_category_name": "AAENP - ENP Professional Practice - Curriculum",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D4B948D5-6516-F111-99A7-005056A7C0C7",
                "course_category_name": "AAENP - ENP Professional Practice Bundle",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": [
            {
                "course_id": "D08B328A-E017-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Empowering Nurse Practitioners in Policy and Innovation",
                "course_type": 1,
                "author_information": "Cindy Weston, DNP, APRN, FNP-BC, FAANP, FAAN",
                "description": "This presentation is designed to inspire and equip nurse practitioners (NPs) to take an active role in shaping health policy and driving innovative solutions to improve patient outcomes. Participants will explore the evolving role of NPs in health policy at local, state, and national levels, and examine real-world examples of impactful innovations led by NPs. The course emphasizes practical strategies for becoming involved in policy work, advocating for greater access to care, and influencing change to promote equity and improve healthcare delivery across diverse populations.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Describe the Nurse Practitioners role in health policy</li>\r\n    <li>Outline innovations for NPs influencing health policy</li>\r\n    <li>Engage in health policy activities to improve access and outcomes</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C01FDB4F-F53E-E711-B09D-005056B10493",
                        "course_category_name": "Leadership & Workforce Development",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4C5C7DA9-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Professional Practice Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D4B948D5-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Professional Practice Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "05EA179B-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Professional Practice - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "E4A93AB7-E017-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Mitigating Malpractice Risks in the ED: Strategies for the ENP",
                "course_type": 1,
                "author_information": "David Warren, DNP, CRNA, FNP, ACNP, ENP",
                "description": "This session will focus on practical strategies and best practices for Emergency Nurse Practitioners to minimize malpractice risks in the Emergency Department (ED). Attendees will explore the concept of \u201cstandard of care\u201d, the anatomy of a malpractice claim, common sources of malpractice claims, learn risk management techniques, and understand the importance of thorough documentation and communication. The session will include case studies, legal insights, and interactive discussions to equip Nurse Practitioners with the tools needed to reduce liability and enhance patient safety. By the end of the presentation, participants will be able to apply these strategies in their daily practice, fostering a safer and legally sound clinical environment.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Understand Legal Standards of Care and the anatomy of a malpractice claim: Explain the legal standards of care applicable to Nurse Practitioners in the Emergency Department and how adherence to these standards can prevent malpractice claims.</li>\r\n    <li>Identify common malpractice risks: Recognize and understand the common sources of malpractice claims in the ED.</li>\r\n    <li>Implement risk management strategies: Apply effective risk management techniques, including thorough documentation and clear communication, to minimize liability in emergency care.</li>\r\n    <li>Develop effective communication skills: Strengthen communication skills with patients, families, and interdisciplinary teams to improve patient outcomes and reduce misunderstandings that can result in legal action.</li>\r\n    <li>Implement proactive patient education: Design and implement patient education strategies that inform patients about their care plans, potential risks, and follow-up instructions, thereby reducing the risk of dissatisfaction and potential malpractice claims.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "05EA179B-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Professional Practice - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D4B948D5-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Professional Practice Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4C5C7DA9-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Professional Practice Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "84586E86-BF29-11DE-88D6-0015171C1B93",
                        "course_category_name": "Legal & Corporate Compliance",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1EA354BE-D2C9-E511-82AF-005056B150D3",
                        "course_category_name": "Regulatory Agencies",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FEC6E955-D5C9-E511-82AF-005056B150D3",
                        "course_category_name": "Risk Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "971E14AF-67DA-E511-9165-005056B141CC",
                        "course_category_name": "Ethical Practice",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "0A68089E-E017-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Imposter Syndrome and the Role of the ED Nurse Practitioner",
                "course_type": 1,
                "author_information": "Kathleen Ahn, DNP, FNP-BC",
                "description": "Nurse Practitioners employed in Emergency Medicine within an academic system have daily interactions with multiple specialty services. From Trauma Surgery to neurology, Ophthalmology to Rheumatology, Interventional Radiology to Colorectal Surgery, Hematology-Oncology and more, the breadth of academic medicine is represented within the system. ED NPs must be prepared to advocate for their patients by identifying a need for consult, formulating an appropriate consultation question, ordering preliminary lab or radiology testing in preparation for a potential consult, and then mastering an effective presentation to the consulting team so that a clinical need or question can be addressed. A case presentation to a specialist must be clear, concise, and tie together all pertinent information. The initial presentation to a consulting team can either forward the case expediently, or create a potential delay in care. When imposter syndrome affects NP practice, these interactions can be challenging.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li> Name 7 skills the NP practicing in the Emergency Department of an Academic Medical Center must develop to facilitate meaningful interactions with a breath of specialty services.</li>\r\n    <li>Discuss at least 5 elements of an effective case presentation to a specialty service within academic medicine.</li>\r\n    <li>What are 3 common feelings of a professional who faces the challenges of Imposter syndrome</li>\r\n    <li>Detail 5 affirmations and/or effective interventions for an NP who is addressing imposter syndrome, or feelings of anxiety and intellectual self-doubt, within the work environment</li>\r\n    <li>Discuss a challenging case presentation you experienced that either succeeded, or did not succeed. Discuss any feelings of intellectual self doubt that may have influenced your clinical discussion, and your opinion of any effect on patient outcome.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D4B948D5-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Professional Practice Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4C5C7DA9-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Professional Practice Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "222C7486-35D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Interpersonal Relationships",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C01FDB4F-F53E-E711-B09D-005056B10493",
                        "course_category_name": "Leadership & Workforce Development",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "463623AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Personal Development",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "05EA179B-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Professional Practice - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "0F66D1CA-E017-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Hard Truths, Soft Landings: Delivering Bad News with Compassion",
                "course_type": 1,
                "author_information": "Rachel Helms, DNP, APRN, AGACNP-BC, FNP-BC, ENP-C",
                "description": "Emergency department providers frequently face the difficult responsibility of delivering bad news to patients and their families. Although this is always a challenging task, the fast-paced and high-pressure environment of the ED adds unique complexities that can intensify the difficulty. This presentation will equip providers with a thoughtful, compassionate approach to handling these tough conversations.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li> Identify the unique challenges of delivering bad news in the emergency department.</li>\r\n    <li>Understand the importance of an intentional approach to delivering bad news.</li>\r\n    <li>Apply key communication techniques to deliver bad news in a compassionate and clear manner.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "05EA179B-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Professional Practice - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D4B948D5-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Professional Practice Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C3BEF86B-35D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Quality Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4C5C7DA9-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Professional Practice Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0E34B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Patient Rights",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3B66D963-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Quality Assurance and Performance Improvement",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "551FF8E5-E017-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Screening for IPV in the ED",
                "course_type": 1,
                "author_information": "Amanda Hitt, DNP, ENP-C, FNP-C and\r\nHilary Ashton Glover, DNP, FNP-C, ENP-C, SANE-A",
                "description": "This webinar will increase awareness of Intimate Partner Violence impact, warning signs and resources",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Identify prevalence of IPV</li>\r\n    <li>Identify 3 risk factors for IPV</li>\r\n    <li>Identify 3 signs &amp; symptoms of IPV</li>\r\n    <li>Describe the screening guidelines for IPV</li>\r\n    <li>Identify 2 interviewing techniques for IPV</li>\r\n    <li>Identify 2 legal considerations related to IPV</li>\r\n    <li>Discuss the mental health impact of IPV</li>\r\n    <li>Identify 1 barrier and 1 solution related to IPV</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4C5C7DA9-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Professional Practice Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A24C16B0-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "57DADFC8-E203-E911-A43F-005056B13721",
                        "course_category_name": "Sexual Abuse & Assault",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "51FB57AE-C98C-EB11-80DF-005056B134EC",
                        "course_category_name": "Intimate Partner Violence",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "05EA179B-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Professional Practice - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB3023AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Knowledge Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C01FDB4F-F53E-E711-B09D-005056B10493",
                        "course_category_name": "Leadership & Workforce Development",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "662CDF16-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Emergency Presentations - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D4B948D5-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Professional Practice Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3FC51DDC-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "4BFCE9F3-E017-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Social Determinants of Health for the ED Provider",
                "course_type": 1,
                "author_information": "Travis McCall, PhD, APRN, CCP",
                "description": "Social determinants of health are non-medical factors that influence the health of individuals, communities, and populations. The Centers for Medicare and Medicaid Services (CMS) has prioritized the need to promote health equity, expand coverage, and improve overall health among patients who benefit from CMS programs. As emergency departments provide access to care for many patients who may be affected by social determinants of health, ENPs are positioned to improve health equity and patient outcomes in the provision of care. This lecture will describe social determinants of health, identify factors that may affect patient health, and discuss the implications of such factors when managing and dispositioning patients in the emergency department.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Describe the influence of social determinants of health outcomes for individuals, communities, and populations.</li>\r\n    <li>Identify factors affecting the health of individuals, communities, and populations within the context of the emergency department.</li>\r\n    <li>Discuss the implications of social determinants of health in the management and disposition of patients in the emergency department.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4C5C7DA9-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Professional Practice Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "05EA179B-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Professional Practice - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F29F524D-D7C9-E511-82AF-005056B150D3",
                        "course_category_name": "Patient Engagement",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D4B948D5-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Professional Practice Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "20607355-35D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Patient Needs",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "0E54130C-E117-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Venous Thromboembolism: Initiation of Pulmonary Embolism Response Teams (PERT)",
                "course_type": 1,
                "author_information": "Speaker: Jolene Donald, AG-ACNP, ENP, FNP, MSN, RN",
                "description": "This course will dive into the pathophysiology, risk stratification, and work-up of patients related to PE and DVT. PERT teams will be discussed including the benefits to both the patient and the hospital.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Identify 3 signs and symptoms of PE and DVT</li>\r\n    <li>Identify diagnostic studies for both PE and DVT</li>\r\n    <li>Identify and utilize 3 risk stratification tools to assist in identification of patient at higher risk for PE who require further work-up</li>\r\n    <li>Name 5 reasons PERTs benefit patients and the hospital</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D4B948D5-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Professional Practice Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4C5C7DA9-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Professional Practice Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "05EA179B-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Professional Practice - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3FC51DDC-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "662CDF16-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Emergency Presentations - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A24C16B0-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4FDB4F21-6F00-E711-9B94-005056B141CC",
                        "course_category_name": "Process Improvement",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.6,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "CC317627-4817-F111-99A8-005056A7C0C7",
                "course_version": 1,
                "name": "Business Start Up Basics",
                "course_type": 1,
                "author_information": "Lamon Norton, NP",
                "description": "Delivery of the imperative start up basics for the clinician who is an aspiring business owner, including legal, financial, and market considerations.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li> Identify key tasks to start a business </li>\r\n    <li>Review fiscal elements necessary to a proforma (business plan).    </li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D4B948D5-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Professional Practice Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB3023AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Knowledge Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "05EA179B-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Professional Practice - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4C5C7DA9-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Professional Practice Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C01FDB4F-F53E-E711-B09D-005056B10493",
                        "course_category_name": "Leadership & Workforce Development",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            }
        ]
    }
];